// Skraćenica za ključeve ekrana "Kuhinjski ekran": tx("act.accept") → $t("kds2.act.accept").
import { fmtDur } from "@/utils/kdsTickets";

export default {
  methods: {
    tx(key, params) {
      return this.$t("kds2." + key, params);
    },
    // "7 min", "1 h 23 min" (na ćirilici "7 мин", "1 ч 23 мин")
    dur(minutes) {
      return fmtDur(minutes, { min: this.tx("unit.min"), h: this.tx("unit.h") });
    },
  },
};
